import type { ValuesObjectProps } from '../types'
import type { ChangeAccordionItemMountProps } from '../types/ChangeAccordionItemMountProps'

export const changeAccordionItemMount = ({
  activeFacets,
  setActiveFacets,
  index,
  values,
  filteredFacets,
}: ChangeAccordionItemMountProps) => {
  if (activeFacets.length >= (filteredFacets?.length ?? 0)) {
    return
  }

  const selectedValues = values.filter(({ selected }) => selected)

  activeFacets.push({
    accordionIndex: index,
    facets: selectedValues.map(({ value }: ValuesObjectProps) => value),
  })
  setActiveFacets(activeFacets)
}
